<template>
  <div v-if="isActive" class="modal is-active">
    <div class="modal-background"/>
    <!-- Modal Trapping Section -->
    <div aria-hidden="true"
         @focus="selectFirstElement()"
         tabindex="0" />
    <!-- Modal Trapping Ends -->
    <div class="modal-card">
      <header class="modal-card-head">
       <div class="modal-card-title" >
        <span class="icon"><i class="fal fa-flag"></i></span>
        <span>{{ $t('report.title') }}</span>
       </div>
      </header>

      <section v-if="!isDone" class="modal-card-body">
        <div class="modal-title">{{ $t('report.understand') }} {{modalData.type}}?</div>
        <div class="form">
          <div class="control">
            <label class="radio is-flex">
              <input type="radio" ref="first_element"
                     name="answer"
                     v-model="chosenSource"
                     value="offensive"
                     tabindex="0">
              <span>{{ $t('report.offensive') }} </span>
            </label>
            <label class="radio is-flex">
              <input type="radio"
                     name="answer"
                     v-model="chosenSource"
                     value="inappropriate"
                     tabindex="0">
              <span>{{ $t('report.inappropriate') }} </span>
            </label>
            <label class="radio is-flex">
              <input type="radio"
                     name="answer"
                     v-model="chosenSource"
                     value="spam"
                     tabindex="0">
              <span>{{ $t('report.spam') }} </span>
            </label>
            <label class="radio is-flex">
              <input type="radio"
                     name="answer"
                     v-model="chosenSource"
                     value="ethics"
                     tabindex="0">
              <span>{{ $t('report.violation') }}  <a href="/legal"
                                                     tabindex="0"
                                                     target="_blank">Terms Of Use</a></span>
            </label>
          </div>
          <div v-if="isError" class="help has-text-danger">{{ $t('report.unable-to-save') }}</div>
        </div>
      </section>
      <footer v-if="!isDone" class="modal-card-foot" >
        <button :class="{'is-loading': inProgress}"
                :disabled=" !isValid || inProgress"
                class="button is-primary" @click="report" >{{ $t('report.title') }}</button>
        <button @click="close" class="button cancel-button" >{{ $t('cancel') }}</button>
      </footer>

      <section v-if="isDone" class="modal-card-body">
        <div>{{ $t('report.thanks') }}</div>
        <div>{{ $t('report.policy-1') }} <a tabindex="0" href="/legal"> {{ $t('report.policies') }} </a> {{ $t('report.policy-2') }}
        </div>
      </section>

      <footer  v-if="isDone" class="modal-card-foot" >
        <button class="button is-primary"
                tabindex="0"
                @keypress.space.enter="close"
                @click="close">{{ $t('done') }}</button>
      </footer>
    </div>
    <!-- Modal Trapping Section -->
    <div aria-hidden="true"
         @focus="selectFirstElement()"
         tabindex="0" />
    <!-- Modal Trapping Ends -->
  </div>
</template>
<script>
import throttle from 'lodash/throttle'

import reportAPI from '@/api/report'

const states = {
  inProgress: 1,
  done: 2,
  error: 3
}

export default {
  data: function () {
    return {
      state: 0,
      chosenSource: '',
      error: '',
      isDone: false,
      modalData: {}
    }
  },
  props: ['parentID'],
  watch: {
    active: function (active) {
      if (active) {
        this.state = 0
        this.chosenSource = ''
      }
    },
    isActive: function () {
      this.updateData()
    }
  },
  computed: {
    isValid: function () {
      return this.chosenSource.length > 0
    },
    inProgress: function () {
      return this.state === states.inProgress
    },
    isError: function () {
      return this.state === states.error
    },
    isActive: function () {
      return this.$store.getters.modalIsVisible('report')
    }
  },
  methods: {
    selectFirstElement: function () {
      this.$refs.first_element.focus()
    },
    updateData: function () {
      this.modalData = this.$store.getters.modalData('report') || {}
      this.isDone = false
      this.chosenSource = ''
    },
    close: function (event) {
      if (event) {
        event.stopPropagation() // prevent showing
      }
      this.$store.dispatch('hideReportModal')
    },
    report: function () {
      if (this.chosenSource) {
        this.sendReport(this.chosenSource)
      }
    },
    sendReport: throttle(function (message) {
      this.state = states.inProgress
      const type = this.modalData.type
      const itemID = this.modalData.id
      const data = { type, itemID, message }
      reportAPI.reportContribution(data).then((response) => {
        this.state = states.done
        this.isDone = true
      }, (error) => {
        this.state = states.error
        this.error = error
      })
    }, 500)
  }
}

</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';
  .modal-card {
    background: #F2F2F2;
    text-align: left;
    border-radius: 0.5rem;
    color: $dark;
    font-weight: initial;
  }

  .modal-title {
    font-size: 1.2rem;
    margin-bottom: 1rem;
    margin-left: 0;
  }

  .form {
  max-width: 350px;
  margin-left: 0;
  padding-bottom: 0.7rem;

    .control {
      display: flex;
      flex-direction: column;
    }
    .radio {
      margin-left: 0;
      padding-bottom: 0.5rem;
    }
    .other {
      align-items: center;
      width: 100%;
      min-width: 100%;
      span{
        display: inline-block;
      }
      input {
        display: inline-block;
        width: 80%;
        margin-left: 0.25rem;
      }
    }
    label {
      align-items: center;
    }
    input {
      margin-right: 0.4rem;
    }
  }
</style>
